import Modal from "react-bootstrap/Modal";
import Sidebar from "../components/Sidebar";

export const NavModal = ({ visible, close, user = null }) => {
  return (
    <Modal
      show={visible}
      onHide={close}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      fullscreen={true}
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <div>
          <Sidebar user={user} />
        </div>
      </Modal.Body>
    </Modal>
  );
};
